import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleRight,
  faAngleDown,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import Loader from "../Loader/Loader";
import "./TreeNode.scss";

export default function TreeNode({
  node,
  level = 0,
  lastElement = false,
  onToggle,
  onSelect,
  isFunderHierarchyLoading,
}) {
  // const [open, setOpen] = useState(node?.onPath);
  const [isLoading, setIsLoading] = useState({ name: "", status: false });

  const hasChildren = node.children?.length > 0;
  const handleToggleClick = () => {
    // console.log("Handle toggle Click... isLoading true =>", node.name);
    onToggle(node.name);
    setIsLoading({ name: node.name, status: true });
  };

  useEffect(() => {
    if (node.name === isLoading.name && node.children[0]?.id !== "more") {
      // console.log("Handle toggle Click... isLoading false =>", node.name);
      setIsLoading({ name: "", status: false });
    }
  }, [node]);

  return (
    <div
      className={`${level > 0 ? "border-start border-2" : ""} ${lastElement ? "border-bottom" : ""}`}
      style={{
        marginLeft: level > 0 ? 20 : 0,
      }}
    >
      <div
        className={`tree-item d-flex align-items-center py-2 px-0 rounded 
        ${node.isSearched ? "bg-secondary-subtle" : ""} ${level < 2 ? "" : ""}`}
        style={{
          cursor: hasChildren ? "pointer" : "pointer",
          marginLeft: 12,
        }}
      >
        {hasChildren && (
          <span className="me-2 text-theme" onClick={handleToggleClick}>
            {node?.onPath ? (
              node.children[0]?.id === "more" ? (
                <FontAwesomeIcon icon={faAngleRight} />
              ) : (
                <FontAwesomeIcon icon={faAngleDown} />
              )
            ) : (
              <FontAwesomeIcon icon={faAngleRight} />
            )}
          </span>
        )}

        <span
          className={` flex-grow-1  ${hasChildren ? "" : "ms-2"} ${level === 0 ? "fw-bold" : ""}`} //onClick={() => handleClick(node.name)}
          onClick={() => {
            // console.log("node name =>", node, node.children);
            node.children.length > 0 ? onSelect(node) : onSelect(node);
            // node.children.length > 0 ? onToggle(node.name) : onSelect(node);
          }}
          title={node.name}
        >
          {/* {node.name === "more" ? (
            <span className="text-muted">Loading...</span>
          ) : ( */}
          {/* // )} */}
          <span>{node.name}</span>
          {isLoading.status && (
            <div class="spinner-grow spinner-grow-sm ms-1" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          )}
        </span>

        {node.isSearched && (
          <span className="text-theme fw-bold">
            <FontAwesomeIcon icon={faCheck} />
          </span>
        )}
      </div>

      {node?.onPath &&
        hasChildren &&
        node.children.map(
          (child, i) =>
            child.id !== "more" && (
              <TreeNode
                key={i}
                node={child}
                level={level + 1}
                lastElement={i === node.children.length - 1}
                onToggle={onToggle}
                onSelect={onSelect}
                isFunderHierarchyLoading={isFunderHierarchyLoading}
              />
            ),
        )}
    </div>
  );
}
